import React from 'react';
import { useForm } from 'react-hook-form';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../../components/base/Dialog/Dialog';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import { Button, Icons, Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import AutoAcceptApplicant from '../AutoAcceptApplicant';
import FieldDTO from '../../../../components/fields/Abstract/FieldDTO';
import { loadUserList } from '../../../User/actions';
import CustomSelectInputWithHelper from '../../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import Switches from '../../../../components/fields/Switches/Switches';
import { LOCAL_STORAGE_APPLICANT_KEY } from '../../../../configs/names';
import RepresentativeDTO from '../../../../dto/RepresentativeDTO';

export function RepresentativeInviteFormModal(props) {
  const {
    onClose = () => {}, onSend = () => {},
  } = props;
  const dto = new RepresentativeDTO();
  const attributes = dto.getAttributesByName();

  const {
    watch, control, getValues, setValue,
  } = useForm({
    defaultValues: {
      is_permanent: false,
      // isMatch: false,
    },
  });

  // React.useEffect(() => {
  //   const subscription = watch(values => {
  //     if (getValues('isMatch')) {
  //       setValue('applicant_id', localStorage.getItem(LOCAL_STORAGE_APPLICANT_KEY));
  //     }
  //   });
  //   return () => subscription.unsubscribe();
  // }, [watch]);

  return (
    <Dialog
      className="uspd-representative-form"
      onClose={onClose}
      open
    >
      <DialogTitle header="Предложение на представительство" title={<Icons onClick={onClose} customIcon icon="close" className="close" />} />
      <DialogContent className="uspd-representative-form-content">
        <div className="uspd-representative-form-box">
          <div className="uspd-representative-form-box-container">
            <div className="uspd-representative-form-box-number">1</div>
            <div className="uspd-representative-form-box-title">Доверенность</div>
          </div>
          <Row className="row-cols-1 mt-3">
            <FieldDTOWithCol
              component={TextInputWithLabel}
              dtoObject={attributes.name_for_applicant}
              control={control}
              variant="material"
              inputClassName="custom-scroll-theme"
              withLabel
            />
          </Row>
          <Row className="row-cols-1 mt-3">
            <FieldDTOWithCol
              control={control}
              type="text"
              component={Switches}
              dtoObject={attributes.is_permanent}
              variant="material"
              withLabel
            />
          </Row>
        </div>
        <div className="uspd-representative-form-box">
          <div className="uspd-representative-form-box-container">
            <div className="uspd-representative-form-box-number">2</div>
            <div className="uspd-representative-form-box-title">Сведения о представителе</div>
          </div>
          <FieldDTO
            control={control}
            component={CustomSelectInputWithHelper}
            dtoObject={attributes.user_id}
            usePortal
            portalClassName="executor-selector"
            loadAction={loadUserList}
            optionFormatter={item => ({ value: item.id, name: item.name })}
            filterName="full_name"
            variant="material"
            withLabel
          />
        </div>
        <div className="uspd-representative-form-box">
          <div className="uspd-representative-form-box-container">
            <div className="uspd-representative-form-box-number">3</div>
            <div className="uspd-representative-form-box-title">Сведения о доверителе</div>
          </div>
          {/* <Row className="row-cols-1 mt-3"> */}
          {/*  <FieldDTOWithCol */}
          {/*    control={control} */}
          {/*    type="text" */}
          {/*    component={Switches} */}
          {/*    dtoObject={attributes.isMatch} */}
          {/*    variant="material" */}
          {/*    withLabel */}
          {/*  /> */}
          {/* </Row> */}
          <AutoAcceptApplicant control={control} getValues={getValues} prefix="applicant." />
        </div>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-buttons">
          <Button variant="secondary" onClick={onClose}>Отменить</Button>
          <Button onClick={() => onSend(getValues())}>Создать</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
